<template lang="pug">
  div.text-left.pa-2
    .step1(v-if="currentStep == 1")
      .s1.basic100--text Use filters to organize orders
      .p2.basic100--text.mt-2 Filter orders by date, status, fulfilment method, payment method and source.
    .step2(v-if="currentStep == 2")
      .s1.basic100--text Change your views
      .p2.basic100--text.mt-2 Select between List View, Calendar View or Status View to manage orders.
      .p2.basic100--text.mt-2 Customize what you see when viewing your order list by adding or hiding specific order details.
    .step3(v-if="currentStep == 3")
      .s1.basic100--text Change your views
      .p2.basic100--text.mt-2 Click on an order to view more details and perform actions for any individual order.
    .step4(v-if="currentStep == 4")
      .s1.basic100--text Update order status as you fulfill orders
      .item.d-flex.mt-2
        .chip.d-flex(style="min-width:85px")
          v-chip.ml-auto.button-AA-tiny.text-uppercase( x-small color="info400" style="height: 20px; border-radius: 10px;" dark) Processing
        .p2.basic100--text.pl-2 Order is awaiting fulfillment
      .item.d-flex.mt-2
        .chip.d-flex(style="min-width:85px")
          v-chip.ml-auto.button-AA-tiny.text-uppercase( x-small color="success400" style="height: 20px; border-radius: 10px;" dark) Ready
        .p2.basic100--text.pl-2 Order is ready to be shipped
      .item.d-flex.mt-2
        .chip.d-flex(style="min-width:85px")
          v-chip.ml-auto.button-AA-tiny.text-uppercase(outlined x-small color="success400" style="height: 20px; border-radius: 10px;" dark) Arranged
        .p2.basic100--text.pl-2 Order has been arranged for shipment
      .item.d-flex.mt-2
        .chip.d-flex(style="min-width:85px")
          v-chip.ml-auto.button-AA-tiny.text-uppercase( x-small color="warning500" style="height: 20px; border-radius: 10px;" dark) Shipping
        .p2.basic100--text.pl-2 Order is on its way to customer
      .item.d-flex.mt-2
        .chip.d-flex(style="min-width:85px")
          v-chip.ml-auto.button-AA-tiny.text-uppercase( x-small color="basic500" style="height: 20px; border-radius: 10px;" dark) Delivered
        .p2.basic100--text.pl-2 Order is delivered to customer
    .step5(v-if="currentStep == 5")
      .s1.basic100--text Skip pages
      .p2.basic100--text.mt-2 Simply jump to a specific page or change the number of orders you wish to view per page.
      
    div.d-flex.mt-4
      .p2.basic100--text.my-auto {{currentStep}}/{{ tour.steps.length }}
      v-spacer
      v-btn.text-uppercase.my-auto.mr-2(v-if="currentStep != 1" small text @click="tour.previousStep")
        span.basic100--text.button-Aa-small Prev
      v-btn.text-uppercase.my-auto(v-if="currentStep == tour.steps.length" small :color="$vuetify.theme.themes[$theme].basic100" @click="clickFinish")
        span.basic800--text.button-AA-small Finish
      v-btn.text-uppercase.my-auto(v-else small :color="$vuetify.theme.themes[$theme].basic100" @click="tour.nextStep")
        span.basic800--text.button-AA-small Next
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TourOrderListView',
  props: {
    tour: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      orderTempData: 'tours/getOrderTempData'
    }),
    currentStep () {
      return this.tour.currentStep + 1
    }
  },
  methods: {
    clickFinish () {
      this.$tours['YezzaTour'].stop()
      let data = {
        extra_data: {
          listView: true
        }
      }
      if (this.orderTempData.extra_data) {
        data.extra_data = { ...this.orderTempData.extra_data, listView: true }
        if (this.orderTempData.extra_data.calendarView && this.orderTempData.extra_data.kanbanView && this.orderTempData.extra_data.orderDetails) {
          data.value = 'completed'
        }
      }
      this.$axios.patch(`/companies/${this.orderTempData.company}/settings/${this.orderTempData.id}`, data)
        .then(resp => {
          this.$store.commit('tours/setOrderTempData', { company: this.orderTempData.company, ...resp.data })
        })
    }
  }
}
</script>

<style scoped>
</style>